import { Injectable } from '@angular/core';
import { AuthService } from '../modules/shared/services/auth.service';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoadingService } from '../modules/shared/services/loading.service';
import { throwError } from 'rxjs';

@Injectable()
export class ErrorIntercepetor
  implements HttpInterceptor {

  constructor(
    private authService: AuthService, private router: Router, private loading: LoadingService
  ) { }

  intercept = (req: HttpRequest<any>, next: HttpHandler) => {
    return next.handle(req).pipe(catchError(err => {
      if (err.status === 401) {
        this.authService.logout();
        this.loading.setLoadingState(false);
        this.router.navigate(['/login']);
      }
      return throwError(err);
    }));
  };
}
